import { useDispatch, useSelector } from 'react-redux';
import FilterBar from '../../components/FilterBar';
import SortBar from '../../components/SortBar';
import FormDialog from '../../components/FormDialog';
import SiteForm from './SiteForm';
import { SiteFilterValues, SiteSortValues } from '../../redux/types';
import {
  sortSitesBy,
  selectSitesState,
  filterSitesBy,
} from '../../redux/slices/sitesSlice';

import { useActionCardStyles } from '../../styles/muiStyles';
import AddIcon from '@material-ui/icons/Add';
import DLIcon from '@material-ui/icons/GetApp';
import React from 'react';
import Button from '@material-ui/core/Button';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';

const menuItems = [
  { value: 'sn-sites-asc', label: 'SN Site ASC' },
  { value: 'sn-sites-desc', label: 'SN Site DESC' },
  { value: 'contact-a-z', label: 'Nom (A - Z)' },
  { value: 'contact-z-a', label: 'Nom (Z - A)' },
  { value: 'sn-concentrateurs-asc', label: 'SN Concentrateur ASC' },
  { value: 'sn-concentrateurs-desc', label: 'SN Concentrateur DESC' },
  { value: 'last-data', label: 'Last Data' },
  { value: 'ts-last-data', label: 'TS Last Data' },
];

const SitesActionCard: React.FC<{
  filterValue: string;
  setFilterValue: (filterValue: string) => void;
  isMobile: boolean;
}> = ({ filterValue, setFilterValue, isMobile }) => {
  const classes = useActionCardStyles();
  const dispatch = useDispatch();
  const { filterBy, sortBy } = useSelector(selectSitesState);

  const handleSortChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    const selectedValue = e.target.value as SiteSortValues;
    dispatch(sortSitesBy(selectedValue));
  };

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = e.target.value as SiteFilterValues;
//    console.log("HandleFilterChange: "+selectedValue);
    dispatch(filterSitesBy(selectedValue));
  };

  return (
    <div>
      <div className={classes.inputs}>
        <div className={classes.searchBarWrapper}>
          <FilterBar
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            label="Sites"
            size={isMobile ? 'small' : 'medium'}
          />
        </div>
        <div className={classes.sortBarWrapper}>
          <SortBar
            sortBy={sortBy}
            handleSortChange={handleSortChange}
            menuItems={menuItems}
            label="Sites"
            size={isMobile ? 'small' : 'medium'}
          />
        </div>
      </div>
      <div style={{ display: 'inline' }}>
      <Button style={{ margin: 'auto 0',/* padding: '9px 35px',*/ float: 'left' }}
        size="large"
        color="primary"
        variant="contained"
  //              className={classes.submitBtn}
        onClick={event =>  window.location.href='/addlogement'}> <AddIcon/> Ajouter un logement
      </Button>
      {/*<Button style={{ margin: 'auto 0', float: 'left', marginLeft: '1rem' }}
        size="large"
        color="primary"
        variant="contained"
  //              className={classes.submitBtn}
        onClick={event =>  window.location.href='/data-export'}> <DLIcon/> Export de données
      </Button>*/}
      <FormControl component="fieldset" style={{ float: 'right', marginBottom: '1rem' }}>
          <FormLabel component="legend" style={{ fontSize: '0.8em' }}>
            Filtrer les logements
          </FormLabel>
          <RadioGroup row value={filterBy} onChange={handleFilterChange}>
            <FormControlLabel
              value="running"
              control={<Radio color="primary" />}
              label="En cours"
            />
            <FormControlLabel
              value="closed"
              control={<Radio color="primary" />}
              label="Terminés"
            />
            <FormControlLabel
              value="all"
              control={<Radio color="primary" />}
              label="Tous"
            />
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
};

export default SitesActionCard;
